import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import LoginPage from "@/components/LoginPage";
import AuthCallback from "@/components/AuthCallback";
import ProtectedRoute from "@/components/ProtectedRoute";
import Dashboard from "@/components/Dashboard";
import PaymentSuccess from "@/components/PaymentSuccess";
import PaymentCancel from "@/components/PaymentCancel";
import LandingPage from "@/components/LandingPage";
// Initialize Firebase Analytics
import { trackPageView } from "@/lib/firebase";

// AppRouter handles session_id detection BEFORE normal routing
// This prevents race conditions with auth
function AppRouter() {
  const location = useLocation();
  
  // Track page views
  useEffect(() => {
    const pageName = location.pathname === '/' ? 'Landing' :
                     location.pathname === '/login' ? 'Login' : 
                     location.pathname === '/dashboard' ? 'Dashboard' : 
                     location.pathname === '/payment/success' ? 'Payment Success' :
                     location.pathname === '/payment/cancel' ? 'Payment Cancel' :
                     'Other';
    trackPageView(pageName);
  }, [location.pathname]);
  
  // Check URL fragment for session_id synchronously during render
  // This MUST happen before ProtectedRoute runs
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route 
        path="/dashboard" 
        element={
          <ProtectedRoute>
            {({ user, setUser }) => <Dashboard user={user} setUser={setUser} />}
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/payment/success" 
        element={
          <ProtectedRoute>
            {() => <PaymentSuccess />}
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/payment/cancel" 
        element={
          <ProtectedRoute>
            {() => <PaymentCancel />}
          </ProtectedRoute>
        } 
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </div>
  );
}

export default App;
